import React, { useState } from 'react';
import {
  Box,
  SimpleGrid,
  Text,
  Heading,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';

interface Service {
  id: number;
  title: string;
  subtitle: string;
  shortDescription: string;
  fullDescription: string;
  image: string;
}

const TabSection: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedService, setSelectedService] = useState<Service | null>(null);

  const services: Service[] = [
    {
      id: 1,
      title: 'Software a Medida',
      subtitle: 'Desarrollo de Software a Medida',
      shortDescription: 'Diseñamos herramientas únicas para tu negocio: simples de usar, alineadas a tus procesos y listas para crecer contigo.',
      fullDescription: 'Diseñamos herramientas únicas para tu negocio: simples de usar, alineadas a tus procesos y listas para crecer contigo. Menos fricción, más productividad y control.',
      image: '/images/1.jpg',
    },
    {
      id: 2,
      title: 'Desarrollos de IA',
      subtitle: 'Inteligencia Artificial aplicada al negocio',
      shortDescription: 'Soluciones de IA que trabajan contigo: asistentes 24/7, automatizaciones, resúmenes, recomendaciones y previsión de demanda.',
      fullDescription: 'Soluciones de IA que trabajan contigo: asistentes 24/7, automatizaciones, resúmenes, recomendaciones y previsión de demanda. Empezamos pequeño, medimos y escalamos. Integrado con tus sistemas y con control humano.',
      image: '/images/2.jpg',
    },
    {
      id: 3,
      title: 'Apps Móviles',
      subtitle: 'Apps Móviles iOS y Android',
      shortDescription: 'Creamos apps que la gente disfruta usar. Desde la idea hasta su publicación, cuidamos diseño, rapidez y una experiencia que fideliza.',
      fullDescription: 'Creamos apps que la gente disfruta usar. Desde la idea hasta su publicación, cuidamos diseño, rapidez y una experiencia que fideliza.',
      image: '/images/3.jpg',
    },
    {
      id: 4,
      title: 'Aplicaciones Web',
      subtitle: 'Aplicaciones Web y Portales',
      shortDescription: 'Aplicaciones web rápidas y seguras para operar, vender o gestionar tu comunidad desde cualquier dispositivo.',
      fullDescription: 'Aplicaciones web rápidas y seguras para operar, vender o gestionar tu comunidad desde cualquier dispositivo. Claras, autogestionables y sin complicaciones.',
      image: '/images/4.jpg',
    },
    {
      id: 5,
      title: 'Soluciones Web3',
      subtitle: 'Soluciones Web3 & Blockchain',
      shortDescription: 'Usamos blockchain donde aporta valor real: comunidades, trazabilidad, membresías o pagos.',
      fullDescription: 'Usamos blockchain donde aporta valor real: comunidades, trazabilidad, membresías o pagos. Experiencia de usuario primero; tecnología al servicio del negocio.',
      image: '/images/visibilidad.jpeg',
    },
    {
      id: 6,
      title: 'Fidelización Tokenizada',
      subtitle: 'Programas de fidelización tokenizados',
      shortDescription: 'Convierte clientes en fans. Tokens como puntos de valor: niveles, recompensas, canjes entre comercios y ventajas exclusivas.',
      fullDescription: 'Convierte clientes en fans. Tokens como puntos de valor: niveles, recompensas, canjes entre comercios y ventajas exclusivas, todo medible.',
      image: '/images/6.jpg',
    },
    {
      id: 7,
      title: 'Tokenización',
      subtitle: 'Tokenización de Activos y Experiencias',
      shortDescription: 'Digitalizamos valor: entradas, obras, membresías o beneficios.',
      fullDescription: 'Digitalizamos valor: entradas, obras, membresías o beneficios. Nuevos ingresos, participación y pertenencia de forma clara y segura.',
      image: '/images/7.jpg',
    },
    {
      id: 8,
      title: 'Marketing Digital',
      subtitle: 'Estrategia y Marketing Digital',
      shortDescription: 'Estrategia, contenidos y campañas que convierten. Contamos historias que conectan, optimizamos inversión y medimos para crecer.',
      fullDescription: 'Estrategia, contenidos y campañas que convierten. Contamos historias que conectan, optimizamos inversión y medimos para crecer.',
      image: '/images/marketing.webp',
    },
    {
      id: 9,
      title: 'Marketplaces',
      subtitle: 'Creación y Escalado de Marketplaces',
      shortDescription: 'Lanzamos tu plataforma de oferta y demanda con confianza: alta de vendedores, pagos, reputación y curación.',
      fullDescription: 'Lanzamos tu plataforma de oferta y demanda con confianza: alta de vendedores, pagos, reputación y curación para lograr liquidez desde el inicio.',
      image: '/images/9.jpg',
    },
    {
      id: 10,
      title: 'Diseño Web',
      subtitle: 'Diseño y Desarrollo Web',
      shortDescription: 'Webs que venden: rápidas, atractivas y pensadas para convertir.',
      fullDescription: 'Webs que venden: rápidas, atractivas y pensadas para convertir. Mensajes claros, SEO base y editor sencillo para que la mantengas sin depender de nadie.',
      image: '/images/10.jpg',
    },
    {
      id: 11,
      title: 'Asesoría Legal Digital',
      subtitle: 'Legal & Cumplimiento para productos digitales',
      shortDescription: 'Te cubrimos en todo lo digital: protección de datos, propiedad intelectual, contratos, términos y políticas.',
      fullDescription: 'Te cubrimos en todo lo digital: protección de datos, propiedad intelectual y licencias, contratos, términos y políticas (web, app, marketplace), publicidad y colaboraciones con influencers, sorteos/promos, y tokenización/Web3. Explicado en claro, a medida y con foco en evitar riesgos desde el diseño.',
      image: '/images/legal.webp',
    },
  ];

  const handleCardClick = (service: Service) => {
    setSelectedService(service);
    onOpen();
  };

  return (
    <Box w="100vw" bg="black" py={10} px={4}>
      <Box maxW="1250px" mx="auto">
        <Heading
          as="h2"
          textAlign="center"
          mb={4}
          fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
          color="white"
        >
          ¿Qué ofrece TokenMeet?
        </Heading>
        <Text
          textAlign="center"
          mb={12}
          fontSize={{ base: 'md', md: 'lg' }}
          color="gray.300"
          maxW="800px"
          mx="auto"
        >
          Todo es a medida. Nos cuentas tu objetivo y te proponemos un plan claro para lanzarlo con impacto.
        </Text>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
          {services.map((service) => (
            <Box
              key={service.id}
              bg="rgba(255, 255, 255, 0.05)"
              borderRadius="lg"
              overflow="hidden"
              cursor="pointer"
              transition="all 0.3s"
              _hover={{
                transform: 'translateY(-8px)',
                boxShadow: '0 8px 30px rgba(14, 241, 250, 0.3)',
                bg: 'rgba(255, 255, 255, 0.08)',
              }}
              onClick={() => handleCardClick(service)}
              border="1px solid"
              borderColor="rgba(255, 255, 255, 0.1)"
            >
              <Image
                src={service.image}
                alt={service.title}
                height="200px"
                width="100%"
                objectFit="cover"
              />
              <VStack align="start" p={6} spacing={3}>
                <Heading as="h3" fontSize="xl" color="white" noOfLines={1}>
                  {service.title}
                </Heading>
                <Text fontSize="sm" color="#0ef1fa" fontWeight="semibold" noOfLines={1}>
                  {service.subtitle}
                </Text>
                <Text fontSize="sm" color="gray.300" noOfLines={3}>
                  {service.shortDescription}
                </Text>
                <Text
                  fontSize="sm"
                  color="#0ef1fa"
                  fontWeight="bold"
                  mt={2}
                  _hover={{ textDecoration: 'underline' }}
                >
                  Ver más →
                </Text>
              </VStack>
            </Box>
          ))}
        </SimpleGrid>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
        <ModalOverlay bg="blackAlpha.800" backdropFilter="blur(10px)" />
        <ModalContent bg="gray.900" color="white" borderRadius="lg" border="1px solid" borderColor="rgba(14, 241, 250, 0.3)">
          <ModalHeader fontSize="2xl" borderBottom="1px solid" borderColor="rgba(255, 255, 255, 0.1)">
            {selectedService?.title}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody py={6}>
            <VStack align="start" spacing={4}>
              <Image
                src={selectedService?.image}
                alt={selectedService?.title}
                width="100%"
                height="300px"
                objectFit="cover"
                borderRadius="md"
              />
              <Text fontSize="lg" color="#0ef1fa" fontWeight="semibold">
                {selectedService?.subtitle}
              </Text>
              <Text fontSize="md" color="gray.300" lineHeight="tall">
                {selectedService?.fullDescription}
              </Text>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TabSection;
